import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ro from './locales/ro.json'
import de from './locales/de.json'
import uk from './locales/uk.json'
import pt from './locales/pt.json'

const messages = {
  en,
  ro,
  de,
  uk,
  pt,
}

// Detect the user's browser language
function detectLanguage() {
  const userLanguages = navigator.languages || [navigator.language || navigator.userLanguage]
  const availableLanguages = Object.keys(messages)
  
  // Check if the user's browser language is available
  for (const lang of userLanguages) {
      const primaryLang = lang.split('-')[0]
      if (availableLanguages.includes(primaryLang)) {
      return primaryLang
    }
  }

  return 'en' // Default language if no match
}

const savedLanguage = localStorage.getItem('userLanguage')
const detectedLanguage = detectLanguage() || savedLanguage

localStorage.setItem('userLanguage', detectedLanguage)

export const i18n = createI18n({
  legacy: false,
  locale: detectedLanguage,
  fallbackLocale: 'en',
  messages,
})

export default i18n